import { useNavigate } from "react-router";
import { cx } from "emotion";
import { MehOutlined } from "@ant-design/icons";
import {
  StyledContainer,
  StyledHeader,
  StyledPadding,
  StyledBody,
  StyledCard,
  StyledHeading,
  StyledDescription
} from "./ErrorBoundary";
import { FormattedMessage } from "react-intl";
import { COPY_TEXT } from "../../utils/constants";
import {
  DesignTheme,
  LAYOUT_ID,
  globalCSSClass,
  normalizeCSSClass
} from "@certa/blocks";
import { Maintenance } from "./Maintenance";
import { AppLoader } from "../../../modules/router/AppLoader";
import { useGetMaintenanceMode } from "@certa/common/hooks/useGetMaintenanceMode";
import { Button, ButtonVariants } from "@certa/catalyst/components/Button";
import { Stack } from "@certa/catalyst/layouts/Stack";
import { useInstanceConfigQuery } from "@certa/queries/hooks/config.hook";

export const ServiceUnavailableError = () => {
  const { isLoading: isConfigLoading } = useInstanceConfigQuery();
  const maintenanceModeConfig = useGetMaintenanceMode();

  const isMaintenanceModeTurnedOn =
    maintenanceModeConfig.isMaintenanceModeEnabled;
  const maintenanceModeMessage = maintenanceModeConfig.messageOnMaintenancePage;

  const navigate = useNavigate();

  if (!!isConfigLoading) {
    return <AppLoader />;
  }

  if (!!isMaintenanceModeTurnedOn) {
    if (maintenanceModeMessage) {
      return (
        <DesignTheme
          id={LAYOUT_ID}
          className={cx(normalizeCSSClass, globalCSSClass)}
        >
          <Maintenance eta={""} msg={{ en: maintenanceModeMessage }} />
        </DesignTheme>
      );
    }
  }
  return (
    <StyledContainer>
      <StyledPadding />
      <StyledBody>
        <StyledCard>
          <StyledHeader>
            <MehOutlined style={{ color: "#ffffff", fontSize: 64 }} />
            <StyledHeading>{COPY_TEXT.OPPS}</StyledHeading>
          </StyledHeader>
          <StyledDescription>
            <FormattedMessage id="errorMessageInstances.serverNotAvailable" />
          </StyledDescription>
          <Stack
            direction="horizontal"
            align="center"
            justify="center"
            gap="24"
            padding="48 12 0 12"
          >
            <Button
              onClick={() => navigate(-1)}
              fullWidth
              variant={ButtonVariants.FILLED}
            >
              <FormattedMessage id="commonTextInstances.goBack" />
            </Button>
          </Stack>
        </StyledCard>
      </StyledBody>
      <StyledPadding />
    </StyledContainer>
  );
};
